/** 表单布局单列化断点（LeapWorldUI-02，D29 移动端 A+B 档）：窄屏恒单列，≥sm 起按 cols 分列，页面不再手写响应式栅格。 */
import type { ReactNode } from 'react'

export type FieldGridProps = {
  /** ≥sm 断点后的列数：2（默认）或 3；1 为始终单列 */
  cols?: 1 | 2 | 3
  className?: string
  children: ReactNode
}

const colsClasses: Record<1 | 2 | 3, string> = {
  1: '',
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3'
}

export function FieldGrid({ cols = 2, className = '', children }: FieldGridProps) {
  // cols=1 时无分列类，数组拼装避免多余空格
  const classes = ['grid grid-cols-1 gap-4', colsClasses[cols], className].filter(Boolean).join(' ')
  return <div className={classes}>{children}</div>
}
